import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HtmlContentDialogModel, HtmlContentDialogResult } from '../abstract-dialog-classes';

@Component({
  selector: 'app-input-content-dialog',
  templateUrl: './input-content-dialog.component.html',
  styleUrls: ['./input-content-dialog.component.css']
})
export class InputContentDialogComponent implements OnInit {

  header: string = '';
  content: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    const data = this.config.data as HtmlContentDialogModel;
    this.header = data.header;
    this.content = data.content;
  }

  ngOnInit(): void {
  }

  onCancel() {
    this.ref.close();
  }

  onSubmit() {
    // console.log('INPUT-CONTENT-DIALOG');
    this.ref.close(new HtmlContentDialogResult(true, this.content));
  }

}
